<div class="mb-2 flex justify-end">
  <pt-button-with-menu
    color="primary"
    type="flat"
    label="Add From Template"
    (buttonClick)="addFromTemplate()"
  >
    <button mat-menu-item (click)="addTask()">Add Task</button>
    <button mat-menu-item (click)="addNotification()">Add Notification</button>
    <button mat-menu-item (click)="addFormIssue()">Add Form Issue</button>
  </pt-button-with-menu>
</div>

<pr-automation-reschedule-list
  [automations]="automations$ | async"
  [patient]="patient$ | async"
  (editAutomation)="edit($event)"
  (cancelAutomation)="cancel($event)"
  (setAutomationPending)="setPending($event)"
/>
